export const coreComponentName = "SdbAppBar";
